exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group>.list-group-item[data-v-5e6e6e5d]:first-child{border-radius:4px 4px 0 0}.list-group>.list-group-item[data-v-5e6e6e5d]:last-child{border-radius:0 0 4px 4px}.panel[data-v-5e6e6e5d]:not(:last-child){margin-bottom:0}.notification[data-v-5e6e6e5d]{padding-bottom:.25rem;padding-top:.25rem}.section[data-v-5e6e6e5d]{position:absolute;top:10px;right:0;z-index:20;padding-right:0}.panel.list-group[data-v-5e6e6e5d]{background-color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e6e6e5d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/ListaArticulosAsignados.vue
// module id = 2533
// module chunks = 0